<template>
  <div>
    <ts-page-title
      :title="$t('certificate.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('certificate.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper>
        <div class="tw-flex tw-justify-end tw-items-center">
          <div class="tw-justify-end tw-space-x-2">
            <a-input-search
              v-model="search"
              :placeholder="$t('certificate.search')"
              style="width: 200px"
            />
          </div>
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.cert_type_name }}</td>
            <td class="tw-text-center">
              {{ record.available_in_year }}
            </td>
            <td class="text-center">
              <a
                href="#"
                class="mr-2 text-primary"
                @click.prevent="onEdit(record)"
              >
                <i class="fa fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('certificate.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "lodash";
import FromAction from "./form.vue";
export default {
  name: "certificateIndex",
  components: {
    FromAction,
  },
  data() {
    return {
      visible: false,
      loading: false,
      showForm: false,
    };
  },
  computed: {
    ...mapState("academic/certificate", ["resources", "pagination"]),
    search: {
      get() {
        return this.$store.state.academic.certificate.search;
      },
      set(newValue) {
        this.$store.commit("academic/certificate/SET_SEARCH", newValue);
        this.$store.commit("academic/certificate/RESET_CURRENT_PAGE");
      },
    },
    columns() {
      return [
        {
          name: this.$t("certificate.certificateType"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("certificate.availableInYear"),
          style: "text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("actions"),
          style: "width:7%; text-align:center",
        },
      ];
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("academic/certificate/fetch", {
          ...attributes,
        })
        .catch((error) => {
          this.loading = false;
          this.$toasted.error(error.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onEdit(record) {
      this.$store.commit("academic/certificate/SET_EDIT_DATA", record);
      this.showForm = true;
    },
    clearEdit() {
      this.$store.commit("academic/certificate/SET_EDIT_DATA", {});
      this.showForm = false;
      this.fetchData();
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search });
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("academic/certificate/RESET_STATE");
    next();
  },
};
</script>
